export default __webpack_public_path__ + "double-sided-eraser.png";